export default "__VITE_ASSET__DTEQGvOP__"